module.exports = (__webpack_require__(0))(45);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/CollectionModel.js from dll-reference girder_lib
// module id = 20
// module chunks = 0